import type { AnyObject } from 'types/AnyObject';
import type { SelectedFilters } from 'uikit';
import { replacerCost } from 'utils/replacerCost';

import type { Dispatch, SetStateAction } from 'react';

import type { ICheckedObjs, IOtherValues } from './types';

export type TCheckedIdsWithSeasonsCost = Record<number, Record<number, number>[] | null>;
export const prepareOtherCostData = ({
    checkedObjects,
    priceValues,
    valueNote,
}: {
    checkedObjects: ICheckedObjs;
    priceValues: IOtherValues;
    valueNote?: Record<string, string>;
}) =>
    Object.entries(checkedObjects).reduce((acc: any[], [otherCostId, otherCostValue]) => {
        // Если не выбрана прочая, не формируем объект для сезонов
        if (!otherCostValue.parent) {
            return acc;
        }

        // Список айдишек выбранных объектов
        const otherObjectList =
            otherCostValue &&
            Object.entries(otherCostValue).reduce((objListAcc: number[], [objId, objValue]) => {
                if (objValue && objId !== 'parent') {
                    objListAcc.push(Number(objId));
                }

                return objListAcc;
            }, []);

        // Список значений для сезонов
        const seasonsList =
            priceValues?.[otherCostId] &&
            Object.entries(priceValues[otherCostId]).reduce((seasonsListAcc: any[], [seasonId, seasonValue]) => {
                if (seasonValue) {
                    seasonsListAcc.push({
                        seasonId: Number(seasonId),
                        ...(seasonValue?.includedCost
                            ? { includedCost: replacerCost(seasonValue.includedCost) }
                            : { isIncluded: seasonValue.isIncluded }),
                    });
                }

                return seasonsListAcc;
            }, []);

        if (valueNote) {
            acc.push({
                otherCostId: Number(otherCostId),
                objectIdList: otherObjectList,
                otherSeasonPrices: seasonsList ?? [],
                rationale: valueNote[Number(otherCostId)],
            });
        } else {
            acc.push({
                otherCostId: Number(otherCostId),
                objectIdList: otherObjectList,
                otherSeasonPrices: seasonsList ?? [],
            });
        }

        return acc;
    }, []);

export const prepareAddOrderOtherToAktKC2Ids = (idsObj: TCheckedIdsWithSeasonsCost) =>
    Object.entries(idsObj).reduce((acc: number[], [key, value]) => {
        if (value) {
            acc.push(Number(key));
        }

        return acc;
    }, []);

export const createFilterChangeHandler =
    (dataArray: AnyObject[], setVisibleHandler: Dispatch<SetStateAction<any[]>>) => (value: SelectedFilters) => {
        const mappedData = dataArray.reduce((acc, item) => {
            acc[item.name] = item;

            return acc;
        }, {});

        if (value?.name?.value?.length) {
            const newVisibleData = value?.name?.value?.reduce(
                (acc: AnyObject[], item: { name: string; value: string }) => {
                    if (mappedData[item.name]) {
                        acc.push(mappedData[item.name]);
                    }

                    return acc;
                },
                [],
            );

            setVisibleHandler(newVisibleData);
        } else {
            setVisibleHandler(dataArray);
        }
    };

export const checkOtherHaveEmptySeasonCostForAct = ({
    checkedIdsWithSeasonCosts,
    seasonIdsWithActs,
}: {
    seasonIdsWithActs: number[];
    checkedIdsWithSeasonCosts: TCheckedIdsWithSeasonsCost;
}) =>
    Object.values(checkedIdsWithSeasonCosts).reduce((acc, costArr) => {
        if (Array.isArray(costArr)) {
            seasonIdsWithActs?.forEach((seasonId: number) => {
                if (costArr.some((cost) => cost[seasonId] === 0)) {
                    acc = true;
                }

                return acc;
            });
        }

        return acc;
    }, false);
